import { testimonials } from '@/mocks/photography';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            客户口碑
          </h2>
          <p className="text-foreground-600 text-sm">超过5000位客户的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.slice(0, 5).map((t) => (
            <div
              key={t.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.service}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(t.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-4">
                {t.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}